import { useIntl } from "react-intl";
import { ISimpleTabeGridColumns } from "src/app/components/SimpleTable/SimpleTable";

export default function useIndexedTableGrid(domain?: string): Array<ISimpleTabeGridColumns> {
    const { formatMessage } = useIntl();

    const gridColumns: Array<ISimpleTabeGridColumns> = [
        {
            field: "WRITE",
            headerName: formatMessage({ id: "content.grid.col.writingType.WRITE" }),
            valueFormatter: ({ data }: any) => (
                <a
                    href={`/content/online?rd.domain%5Btype%5D=contains&rd.domain%5Bfilter%5D=${domain}&content.writingType%5Btype%5D=contains&content.writingType%5Bfilter%5D=WRITE`}
                >
                    {data.WRITE || "0 / 0 "}
                </a>
            ),
        },
        {
            headerName: formatMessage({ id: "content.grid.col.writingType.AI_AUTO" }),
            field: "AI_AUTO",
            valueFormatter: ({ data }: any) => (
                <a
                    href={`/content/online?rd.domain%5Btype%5D=contains&rd.domain%5Bfilter%5D=${domain}&content.writingType%5Btype%5D=contains&content.writingType%5Bfilter%5D=Auto`}
                >
                    {data.AI_AUTO || "0 / 0 "}
                </a>
            ),
        },
        {
            headerName: formatMessage({ id: "content.grid.col.writingType.AI_MANUAL" }),
            field: "AI_MANUAL",
            valueFormatter: ({ data }: any) => (
                <a
                    href={`/content/online?rd.domain%5Btype%5D=contains&rd.domain%5Bfilter%5D=${domain}&content.writingType%5Btype%5D=contains&content.writingType%5Bfilter%5D=Manual`}
                >
                    {data.AI_MANUAL || "0 / 0 "}
                </a>
            ),
        },
        {
            headerName: formatMessage({ id: "content.grid.col.writingType.TRANSLATE" }),
            field: "TRANSLATE",
            valueFormatter: ({ data }: any) => (
                <a
                    href={`/content/online?rd.domain%5Btype%5D=contains&rd.domain%5Bfilter%5D=${domain}&content.writingType%5Btype%5D=contains&content.writingType%5Bfilter%5D=Translate`}
                >
                    {data.TRANSLATE || "0 / 0 "}
                </a>
            ),
        },
        {
            headerName: formatMessage({ id: "content.grid.col.writingType.EXPIRED" }),
            field: "EXPIRED",
            valueFormatter: ({ data }: any) => (
                <a
                    href={`/content/online?rd.domain%5Btype%5D=contains&rd.domain%5Bfilter%5D=${domain}&content.writingType%5Btype%5D=contains&content.writingType%5Bfilter%5D=Expired`}
                >
                    {data.EXPIRED || "0 / 0 "}
                </a>
            ),
        },
    ];
    return gridColumns;
}
